import { combineReducers } from "redux";
import waiter from "./waiter-reducer";
// import tableInvoiceReducer from "./invoice-reducer";


const reducers = combineReducers({
    waiter: waiter,
    // tableInvoiceReducer: tableInvoiceReducer
})

export default reducers

export type RootState = ReturnType<typeof reducers>